import { gql } from '@apollo/client';
import { mutate } from './Apollo';
import { getUrlHashParams } from '../../Helpers/getUrlHashParams';

const SEND_FORM_ERROR = gql`
  mutation SendFormError(
    $formId: String!
    $errorMessage: String!
    $componentId: String
    $iframeId: String
    $parentPage: String
    $userAgent: String!
  ) {
    sendFormError(
      formId: $formId
      errorMessage: $errorMessage
      componentId: $componentId
      iframeId: $iframeId
      parentPage: $parentPage
      userAgent: $userAgent
    ) {
      formErrorSent
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const sendFormErrorToGateway = ({
  formId,
  errorMessage,
  iFrameId,
  componentId,
}) => {
  if (
    ['production-na', 'production-eu', 'staging', 'development'].includes(
      process.env.NEXT_PUBLIC_ENV
    )
  ) {
    const parentPage = getUrlHashParams()?.parentPageUrl;
    mutate({
      mutation: SEND_FORM_ERROR,
      variables: {
        formId,
        errorMessage,
        componentId:
          componentId !== undefined ? String(componentId) : undefined,
        iframeId: iFrameId !== undefined ? String(iFrameId) : undefined,
        parentPage: parentPage !== undefined ? String(parentPage) : undefined,
        userAgent: String(navigator?.userAgent ?? ''),
      },
    });
  }
};
